function isMobileOrTablet() {
  return /(android|iphone|ipad|mobile)/i.test(navigator.userAgent)
}

function objectToGetParams(object: {
  [key: string]: string | number | null | undefined
}) {
  const params = Object.entries(object)
    .filter(([, value]) => value !== undefined && value !== null)
    .map(
      ([key, value]) =>
        `${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`,
    )

  return params.length > 0 ? `?${params.join('&')}` : ''
}

export const openPopupWindow = (url: string) => {
  const width = Math.max(Math.floor(window.innerWidth / 2), 540)
  const height = Math.max(Math.floor(window.innerHeight / 2), 600)
  const top = screen.height / 2 - height / 2
  const left = screen.width / 2 - width / 2

  window.open(
    url,
    'share_window',
    [
      `height=${height}`,
      `width=${width}`,
      `top=${top}`,
      `left=${left}`,
      'channelmode=0',
      'directories=0',
      'fullscreen=0',
      'location=0',
      'menubar=0',
      'scrollbars=0',
      'status=0',
      'titlebar=0',
      'toolbar=0',
    ].join(','),
  )
}

export function twitterLink(
  url: string,
  {
    title,
    via,
    hashtags = [],
    related = [],
  }: { title?: string; via?: string; hashtags?: string[]; related?: string[] },
) {
  return (
    'https://twitter.com/share' +
    objectToGetParams({
      url,
      text: title,
      via,
      hashtags: hashtags.length > 0 ? hashtags.join(',') : undefined,
      related: related.length > 0 ? related.join(',') : undefined,
    })
  )
}

export function facebookLink(
  url: string,
  { quote, hashtag }: { quote?: string; hashtag?: string },
) {
  return (
    'https://www.facebook.com/sharer/sharer.php' +
    objectToGetParams({
      u: url,
      quote,
      hashtag,
    })
  )
}

export function whatsappLink(
  url: string,
  { title, separator = ' ' }: { title?: string; separator?: string },
) {
  return (
    'https://' +
    (isMobileOrTablet() ? 'api' : 'web') +
    '.whatsapp.com/send' +
    objectToGetParams({
      text: title ? title + separator + url : url,
    })
  )
}

export function linkedinLink(
  url: string,
  {
    title,
    summary,
    source,
  }: { title?: string; summary?: string; source?: string },
) {
  return (
    'https://linkedin.com/shareArticle' +
    objectToGetParams({ url, mini: 'true', title, summary, source })
  )
}

export function telegramLink(url: string, { title }: { title?: string }) {
  return (
    'https://telegram.me/share/url' +
    objectToGetParams({
      url,
      text: title,
    })
  )
}
